import { render, staticRenderFns } from "./VincularCidades.vue?vue&type=template&id=098d60c4&scoped=true&"
import script from "./VincularCidades.vue?vue&type=script&lang=js&"
export * from "./VincularCidades.vue?vue&type=script&lang=js&"
import style0 from "./VincularCidades.vue?vue&type=style&index=0&id=098d60c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098d60c4",
  null
  
)

export default component.exports